export default "__VITE_ASSET__D1rno_W2__"